export enum SistemaIntegradoIdpk {
    SistemaNaoIdentificado = 0,
    NewSales = 1,
    Gestok = 77477,
    MercurioWebApp = 514871,
    CatalogoDigital = 753159,
    FintechApp = 954871,
    SmartPos = 7458751,
    Sicos = 7563154,
    MercurioImpressao = 9817861,
    MercurioLocal = 517341123,
}
